import * as React from 'react';
import { DateField, useTranslate, useRecordContext } from 'react-admin';
import { Typography, Card, CardContent, Box, Grid } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { Admin } from '../types';

const Aside = () => {
    const record = useRecordContext<Admin>();
    return (
        <Box width={400} display={{ xs: 'none', lg: 'block' }}>
            {record && <EventList />}
        </Box>
    );
};

const EventList = () => {
    const record = useRecordContext<Admin>();
    const translate = useTranslate();
    // const [locale] = useLocaleState();

    return (
        <Box ml={2}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {translate('resources.admins.fieldGroups.history')}
                    </Typography>
                    <Grid container rowSpacing={1} columnSpacing={1}>
                        <Grid item xs={6} display="flex" gap={1}>
                            <AccessTimeIcon fontSize="small" color="disabled" />
                            <Box flexGrow={1}>
                                <Typography variant="body2">
                                    {translate(
                                        'resources.admins.fields.date_joined'
                                    )}
                                </Typography>
                                <DateField
                                    record={record}
                                    source="date_joined"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={6} display="flex" gap={1}>
                            <AccessTimeIcon fontSize="small" color="disabled" />
                            <Box flexGrow={1}>
                                <Typography variant="body2">
                                    {translate(
                                        'resources.admins.fields.last_login'
                                    )}
                                </Typography>
                                <DateField
                                    record={record}
                                    source="last_login"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Aside;
